module.exports = __webpack_public_path__ + "img/Logo.c3cf4ac8.png";